// extracted by mini-css-extract-plugin
module.exports = {"nav":"p1A7_y"};